module.exports = __webpack_public_path__ + "static/media/google-icon.ab3cfb3c.svg";